module.exports = __webpack_public_path__ + "img/400fddf.png";